<template>
  <div class="border border-gray-300 p-3 rounded-xl relative h-52 flex flex-col justify-between">
    <div class="flex items-center space-x-4">
      <!-- First div -->
      <div class="rounded-full w-12 h-12 flex justify-center items-center bg-vice-teal-600">
        <img src="/image/icons/computer.svg" alt="computer-icon" width="20" height="20" class="" />
      </div>
      <!-- Second div -->
      <div class="">
        <div class="device-type-label-regular font-medium">Computer</div>
        <div class="device-label-regular font-medium">
          <span>{{ getOSInfo() }} & {{ getBrowserNameAndVersion() }}</span>
        </div>
      </div>
    </div>

    <!-- Microphone selector -->
    <DefaultDeviceSelector
      deviceIcon="/image/icons/microphone.svg"
      deviceType="Microphone"
      :deviceKind="DEVICES_KINDS.AUDIO_INPUT"
    ></DefaultDeviceSelector>

    <!-- Speaker selector -->
    <DefaultDeviceSelector
      deviceIcon="/image/icons/speaker.svg"
      deviceType="Speaker"
      :deviceKind="DEVICES_KINDS.AUDIO_OUTPUT"
    ></DefaultDeviceSelector>
  </div>
</template>
<script>
import DefaultDeviceSelector from '@/Components/DeviceAndSessionSetup/DefaultDeviceSelector.vue';
import { DEVICES_KINDS } from '@/Utils/vice-constants';
import { getBrowserNameAndVersion, getOSInfo } from '@/Utils/helpers';

export default {
  name: 'DefaultDevicesSlot',
  components: {
    DefaultDeviceSelector,
  },
  setup() {
    return {
      DEVICES_KINDS,
      getOSInfo,
      getBrowserNameAndVersion,
    };
  },
};
</script>
<style scoped>
.device-type-label-regular {
  color: #881337;
  font-size: 16px;
}

.device-label-regular {
  font-size: 12px;
  color: #4b4b4b;
}
</style>
